import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class E2emechanizationService {

  getEventRoute = '/api/e2e';

  constructor(private dataService: DataService) {
  };

  getFarmerDetailsList(regionid: number, divisionid: number, subdivisionid: number, blockid: number,financialYearId:number, refresh: boolean) {
    return this.dataService.getData('/api/e2e/farmerlist/' + regionid + '/' + divisionid + '/' + subdivisionid + '/' + blockid + '/' + financialYearId, refresh);
  }

  getFarmerEventList(farmerid: number, refresh: boolean) {
    return this.dataService.getData('/api/e2e/eventlistbyadmin/' + farmerid, refresh);
  }

  getFarmerDetailList(farmerid: number, refresh: boolean) {
    return this.dataService.getData('/api/e2e/farmerinfoshowadminbyid/' + farmerid, refresh);
  }
  getPaymentDetailList(farmerid: number, refresh: boolean) {
    return this.dataService.getData('/api/e2e/paymentlist/' + farmerid, refresh);
  }
  getEntrepreneurDetailsList(regionid: number, divisionid: number, subdivisionid: number, blockid: number,financialYearId:number, refresh: boolean) {
    return this.dataService.getData('/api/e2e/entrepreneurlist/' + regionid + '/' + divisionid + '/' + subdivisionid + '/' + blockid +'/'+financialYearId, refresh);
  }

  getDashboardList(regionid: number, divisionid: number, subdivisionid: number, blockid: number,financialYearId:number, refresh: boolean) {
    return this.dataService.getData('/api/e2e/dashboard/' + regionid + '/' + divisionid + '/' + subdivisionid + '/' + blockid + '/' + financialYearId, refresh)
  }

  getBlockList(regionid: number, divisionid: number, subdivisionid: number, blockid: number,financialYearId:number, refresh: boolean) {
    return this.dataService.getData('/api/e2etarget/targetlist/' + regionid + '/' + divisionid + '/' + subdivisionid + '/' + blockid + '/' + financialYearId, refresh)
  }

  getTargetDivisionList(regionid: number, divisionid: number, refresh: boolean, financialYearId: number = 0) {
    return this.dataService.getData('/api/e2etarget/targetbydivisionid/' + regionid + '/' + divisionid + (financialYearId ? '/' + financialYearId : ''), refresh)
  }

  addBlock(data: any) {
    return this.dataService.post('/api/e2etarget/save', data)
  }

  // Crop master: crops, and the crops of a financial year with their target and amount.
  getCropTypeList(refresh: boolean) {
    return this.dataService.getData('/api/e2ecropmaster/croptype', refresh);
  }

  saveCropType(data: any) {
    return this.dataService.post('/api/e2ecropmaster/croptype', data);
  }

  getFinancialYearCropList(financialYearId: number, refresh: boolean) {
    return this.dataService.getData('/api/e2ecropmaster/financialyearcrop/' + financialYearId, refresh);
  }

  saveFinancialYearCrop(data: any) {
    return this.dataService.post('/api/e2ecropmaster/financialyearcrop', data);
  }

  deleteFinancialYearCrop(id: number) {
    return this.dataService.post('/api/e2ecropmaster/financialyearcrop/delete/' + id, null);
  }

  // getById(id: number, refresh: boolean) {
  //   return this.dataService.getData('/api/implement/implementDetail/' + id, refresh);
  // }

  // save(result: any) {
  //   return this.dataService.post('/api/implement/', result).map(response => {
  //     this.dataService.clearRouteCache(this.getEventRoute);
  //     return response;
  //   });
  // }

  // delete(id: number) {
  //   return this.dataService.post('/api/implement/delete/' + id, null).map(response => {
  //     this.dataService.clearRouteCache(this.getEventRoute);
  //     return response;
  //   });
  // }

  getDivisionTargetList(regionid: number, divisionid: number,financialYearId:number, refresh: boolean) {
    return this.dataService.getData('/api/e2etarget/divisiontargetlist/' + regionid + '/' + divisionid + '/'+ financialYearId, refresh)
  }

  getDivisionTarget(refresh: boolean, financialYearId: number = 0) {
    return this.dataService.getData('/api/e2etarget/divisiontargetbystate' + (financialYearId ? '/' + financialYearId : ''), refresh)
  }


  addDistrict(data: any) {
    return this.dataService.post('/api/e2etarget/divisiontargetsave', data)
  }



}
